


























import { Component, Provide, Vue } from 'vue-property-decorator';

@Component
export default class HomePatients extends Vue {
  @Provide() private error: boolean = false;

  get patients() {
    return this.$pdc.entities!.patients.storedEntity;
  }

  get lastPatients() {
    return this.$pdc.doctor!.lastPatients;
  }
  /*get filterPatients() {
    const date = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
    return this.patients.list.filter((x: any) => x.)
  }*/

  created() {
    this.$pdc
      .doctor!.getLastPatients()
      .then(() => {
        this.error = false;
      })
      .catch(() => {
        this.error = true;
      });
  }
}
